import { defineStore } from "pinia";
import { User } from "@/types";
import { AxiosResponse } from "axios";
import { useApi } from "@/services";
import { useAxios } from "@/config";
interface UserAdminState {
  users: User[];
  organisationsList: string[];
  coverHolderList: string[];
  groups: string[];
  currentUser: string;
  currentUserGroups: string[];
}
export const useUserAdmin = defineStore("userAdmin", {
  state: (): UserAdminState => ({
    users: [],
    organisationsList: [],
    coverHolderList: [],
    groups: [],
    currentUser: "",
    currentUserGroups: [],
  }),
  actions: {
    async listCoverHolders(param: { attributeName: string }) {
      this.coverHolderList = await useAxios()
        .$http.get(useApi().getAssignedCustomAttributes)
        .then((r: AxiosResponse<any[]>) => {
          const list = r.data
            .filter(({ name }) => name === `custom:${param.attributeName}`)
            .map((v: any) => v.values);
          return list.length ? list[0] : [];
        });
    },
    async listOrganisations() {
      this.organisationsList = await useAxios()
        .$http.get(useApi().existingSettings)
        .then((r: AxiosResponse<any[]>) => r.data);
    },
  },
});
